import {
    Component,
    OnInit,
    ChangeDetectorRef,
    AfterViewInit,
    Output,
    EventEmitter,
    Input
} from "@angular/core";

@Component({
    selector: "app-custom-modal",
    templateUrl: "./custom-modal.component.html",
    standalone: false
})
export class CustomModalComponent implements OnInit, AfterViewInit {
    @Input() hideCross = false;
    @Input() hideHeader = false;
    @Input() hideFooter = false;
    @Input() ActiveTabId = false;
    @Input() applyCustmCSS: any;
    @Input() HeaderText: string;
    

    constructor(private cd: ChangeDetectorRef) {}

    @Output()
    oncrossBtnClick = new EventEmitter<any>();

    ngAfterViewInit() {
        this.cd.detectChanges();
    }

    ngOnInit() {}

    closeModal() {
        this.oncrossBtnClick.emit(true);
    }
}
